import Swiper from 'swiper';
import HelperCtrl from '@/inc/_helper';


const Helper = new HelperCtrl();
function SwiperCtrl() {
	this.init()
}

SwiperCtrl.prototype.init = function () {
	let seminarCourseSwiper = new Swiper('.ls-seminar-swiper-container', this.seminarCourse())
	let gnaviSwiper = new Swiper('.gnavi-content-scroll', this.gnavi())
	let bookSwiper = new Swiper('.book-container', this.book())
	// let frontPageSwiper = new Swiper('.swiper-container', this.frontPage)
}

SwiperCtrl.prototype.seminarCourse = function () {
	return {
		loop: true,
		// effect: 'fade',
		pagination: {
			el: '.ls-seminar-swiper-pagination',
			clickable: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 1500
	}
}

SwiperCtrl.prototype.gnavi = function () {
	return {
		direction: 'vertical',
		slidesPerView: 'auto',
		freeMode: true,
		scrollbar: {
			el: '.gnavi-scrollbar',
		},
		mousewheel: true,
	}
}

SwiperCtrl.prototype.book = function () {
	var bookSetting;
	if (Helper.isMobile()) {
		bookSetting = {
			pagination: '.book-pagination',
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 20,
			// freeMode: true
		};
	} else {
		bookSetting = {
			pagination: {
				el: '.book-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.book-next',
				prevEl: '.book-prev',
			},
			slidesPerView: 4,
			spaceBetween: 60
		};
	}

	return bookSetting
}

SwiperCtrl.prototype.frontPage = function () {
	return {
		pagination: '.slide-pagination',
		nextButton: '.slide-next',
		prevButton: '.slide-prev',
		slidesPerView: 'auto',
		centeredSlides: true,
		paginationClickable: true,
		spaceBetween: 10,
		effect: 'coverflow',
		speed: 700,
		autoplay: {
			delay: 7800,
			disableOnInteraction: false
		},
	}
}

export default SwiperCtrl